import { Drawer, DrawerContent } from '~/components/ui/drawer'
import { ShareDialogContent } from './ShareModalContent'
import { ImageAsset } from './Interfaces/ListingsInterface'
// this is a mobile share drawer
export default function MobileShareDrawer({ isShareOpen, media, url, toggleShareOpen }: { isShareOpen: boolean, media: ImageAsset, url: string, toggleShareOpen: VoidFunction }) {
    return (
        <>
            <Drawer open={isShareOpen} onOpenChange={toggleShareOpen}>
                <DrawerContent >
                    <ShareDialogContent url={url} title={"Share this Property"} media={media?.url} toggleShareOpen={toggleShareOpen} />
                </DrawerContent>
            </Drawer>
        </>
    )
}
